import styled from 'styled-components';

export const SingleStepFormContainer = styled.div`
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: relative;

  .singleStepFormContainer {
    height: 100%;
    overflow: auto;
  }

  .dynamic-form--container {
    position: relative;
    height: 100%;
    padding: 0;
    max-width: 1192px;
    margin: 0 auto;
  }

  .signup-form--header {
    position: absolute;
    width: 100%;
    padding: 40px;
    max-width: 1192px;
    transform: translate(-50%);
    left: 50%;
    z-index: 9999;
    pointer-events: none;

    @media (max-width: 575px) {
      top: -92px;
    }

    .signup-form--title {
      display: none;
    }

    .slick-prev {
      z-index: 1;
      padding: 0;
      top: 0;
      left: 0;
      background: var(--white);
      height: 35px;
      width: 80px;
      pointer-events: all;

      &:before {
        border: solid black;
        border-width: 0 3px 3px 0;
        display: inline-block;
        padding: 6px;
        content: '';
        transform: rotate(135deg);
        -webkit-transform: rotate(135deg);
        opacity: 1;
        position: absolute;
        left: 5px;
        top: 5px;

        @media (max-width: 575px) {
          padding: 5px;
        }
      }

      span {
        font-size: 20px;
        color: var(--darkest);
        font-weight: var(--font-weight-800);
        font-family: var(--font-family);
        left: 30px;
        position: absolute;
        top: 11px;

        @media (max-width: 575px) {
          font-size: 16px;
          left: 23px;
          top: 11px;
        }
      }
    }
  }

  .signup-form--form {
    .data-layer-form {
      max-width: 600px;
      min-height: calc(100vh - 110px);
      &.form-step-0 {
        max-width: 870px;
      }
      padding: 40px;
      margin: 0;

      @media (max-width: 575px) {
        padding: 30px 20px 100px;
        height: calc(100vh - 102px);
        max-height: calc(100vh - 102px);
        overflow: scroll;
      }

      .signup-form--submit-button {
        display: none;
      }

      &.form-step-4 {
        .form-step--title {
          font-family: var(--font-family);
          font-size: var(--font-size-28);
          font-weight: var(--font-weight-800);
          line-height: var(--line-height-120);
          color: var(--darkest);
          text-align: center;
          margin-bottom: 0;
          padding: 0 80px;

          @media (max-width: 767px) {
            font-size: 23px;
            line-height: var(--line-height-120);
          }

          @media (max-width: 575px) {
            text-align: left;
            padding: 0;
          }
        }
        .form-step--instructions {
          font-size: var(--font-size-20);
          font-weight: var(--font-weight-400);
          line-height: var(--line-height-150);
          color: var(--darkest);
          text-align: center;
          margin: 5px 0 30px;

          @media (max-width: 767px) {
            font-size: 17px;
            line-height: var(--line-height-150);
          }

          @media (max-width: 575px) {
            text-align: left;
            margin-bottom: 20px;
          }
        }
        .signup-form--submit-button {
          display: inline;
          height: 60px;
          margin: 0;
          box-shadow: none;
        }
        .form-field {
          margin-bottom: 20px;

          .text-field-label {
            @media (max-width: 767px) {
              top: 0;
            }
          }
        }
      }
    }

    .form-field {
      text-align: center;
      margin-bottom: 30px;

      &:last-child {
        margin-bottom: 0;
      }

      &.Primary_Industry__c {
        margin-bottom: 0;
      }

      &.businessFocusResorCommFORMHELPER {
        &::before {
          content: 'What kind of jobs does your company focus on?';
          font-family: var(--font-family);
          font-size: var(--font-size-h3) !important;
          font-weight: var(--font-weight-900);
          line-height: var(--line-height-110);
          letter-spacing: var(--letter-spacing--0-03);
          text-align: center;
          width: 100%;
          display: block;
          color: var(--darkest);
          padding: 0 50px;
          margin-bottom: 30px;
          background: transparent;

          @media (max-width: 767px) {
            font-size: 23px !important;
            line-height: var(--line-height-120);
            padding: 0 100px;
          }

          @media (max-width: 575px) {
            padding: 0;
            text-align: left;
          }
        }
      }

      &.signup-form--hp123-item {
        margin: 0;
      }

      .signup-form-button--submit-button {
        display: none;
      }

      .radio-field--group {
        .radio-field--title {
          &:not([for='businessFocusResorCommFORMHELPER']):not(
              [for='businessFocusNewConRemodelSRFORMHELPER']
            ) {
            font-size: var(--font-size-h3) !important;
            font-weight: var(--font-weight-800);
            line-height: var(--line-height-110);
            letter-spacing: var(--letter-spacing--0-04);
            text-align: center;
            width: 100%;
            display: block;
            color: var(--darkest);
            padding: 0 50px;
            background: transparent;
            margin-bottom: 0;

            @media (max-width: 767px) {
              font-size: 23px !important;
              line-height: var(--line-height-120);
            }

            @media (max-width: 575px) {
              padding: 0;
              text-align: left;
            }
          }
          &[for='businessFocusResorCommFORMHELPER'],
          &[for='businessFocusNewConRemodelSRFORMHELPER'] {
            font-size: var(--font-size-18) !important;
            font-weight: 800;
            color: var(--darkest);

            @media (max-width: 575px) {
              width: 100%;
              display: block;
              text-align: left;
            }
          }
        }

        .radio-field--instructions {
          margin-top: 20px;

          @media (max-width: 767px) {
            font-size: 17px !important;
          }

          @media (max-width: 575px) {
            text-align: left;
            margin: 10px 0 0;
          }
        }

        .radio-field-wrapper {
          height: auto;
          justify-content: center;
          margin-top: 30px;

          .radio-div {
            flex: auto;
            width: 50%;
            margin: 0;

            label {
              border: 1px solid var(--grey-6);
              border-radius: 0;
              height: 62px;
              margin: 0;
              font-family: var(--font-family-body);
              font-size: var(--font-size-20);
              font-weight: var(--font-weight-400);
              line-height: var(--line-height-150);
              color: var(--grey-8);

              @media (max-width: 767px) {
                font-size: var(--font-size-16);
              }
            }

            &.selected {
              label {
                border: 2px solid var(--titan-blue-3) !important;
                background-color: #2270ee10;
              }
            }
          }

          &#Primary_Industry__c {
            gap: 20px;

            @media (max-width: 575px) {
              overflow: hidden;
            }

            .radio-div {
              width: calc((100% - 40px) / 3);
              max-width: calc((100% - 40px) / 3);

              @media (max-width: 575px) {
                width: calc(50% - 10px);
                max-width: calc(50% - 10px);
              }

              label {
                border: 1px solid var(--darkest);
                font-size: var(--font-size-20);
                height: 70px;

                @media (max-width: 767px) {
                  font-size: 17px;
                }

                @media (max-width: 575px) {
                  height: 84px;
                }
              }
            }
          }

          &#No_of_Technicians__c {
            gap: 20px;

            .radio-div {
              width: calc(50% - 10px);
              max-width: calc(50% - 10px);

              label {
                border: 1px solid var(--darkest);
                font-size: var(--font-size-20);
                height: 70px;

                @media (max-width: 767px) {
                  font-size: 17px;
                }

                @media (max-width: 575px) {
                  height: 66px;
                }
              }
            }
          }

          &#businessFocusResorCommFORMHELPER,
          &#businessFocusNewConRemodelSRFORMHELPER {
            margin-top: 10px;
          }
        }
      }
    }

    .other-options-container {
      height: calc(100vh - 180px);
      position: relative;

      @media (max-width: 575px) {
        height: fit-content;
      }

      .other-industries-container {
        padding: 0;
        height: 100%;

        @media (max-width: 575px) {
          height: fit-content;
        }

        .signup-form--title {
          margin-bottom: 40px;
          font-weight: var(--font-weight-800);
        }

        .signup-form--other-industry-header {
          .slick-prev {
            @media (max-width: 575px) {
              top: 5px;
            }
          }
        }

        .signup-form--other-industry-search,
        .signup-form--other-industry-radio {
          max-width: 520px;
          margin: 15px 125px 0;

          @media (max-width: 575px) {
            max-width: 100%;
            margin: 0;
          }
        }
        .signup-form--other-industry-radio {
          height: 100% !important;
          max-height: 100% !important;
          overflow: auto;
          scrollbar-width: none;
          -ms-overflow-style: none;
          &::-webkit-scrollbar {
            display: none;
          }

          @media (max-width: 575px) {
            margin-top: 15px;
          }

          .radio-field--group .radio-field-wrapper {
            gap: 20px;
            margin-top: 15px;
            position: relative;

            .radio-div {
              width: 100%;
              height: 50px;
              max-width: 100%;
              max-height: 50px;

              label {
                height: 100%;
                border: 1px solid var(--darkest);
                color: var(--darkest);
              }
            }
          }
        }
      }
    }
  }

  .signup-form--footer {
    visibility: hidden;
    opacity: 0;
    height: 0;
    padding: 0 40px;
    transition: all 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);

    * {
      color: var(--darkest) !important;
      margin: 0;
    }
    a {
      text-decoration: underline;
    }
  }

  .modal-close-x {
    display: none;
  }
`;

export const FullModalContainer = styled.div`
  width: 100%;
  position: relative;
  background: white;
  max-width: 100%;
  position: relative;

  .full-modal-header--wrapper {
    width: 100%;
    margin: 0px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 9999;
    padding: 40px;
    height: 110px;

    @media (max-width: 575px) {
      padding: 30px 20px 42px;
      height: 102px;
    }
  }

  .single-step-form--container {
    height: calc(100vh - 110px) !important;

    @media (max-width: 575px) {
      height: calc(100vh - 102px) !important;
    }
  }

  .dynamic-form--container {
    box-shadow: none !important;
    @media (max-width: 575px) {
      height: calc(100vh - 102px) !important;
    }
  }

  .single-step-form--progress-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background: #ddf8e5;
    width: 100%;
    max-width: min(520px, calc(100% - 200px));
    height: 6px;
    border-radius: 6px;
    position: absolute;
    left: 50%;
    transform: translate(-50%);

    .single-step-form--progress {
      background: var(--green);
      height: 6px;
      border-radius: 6px;
    }

    @media (max-width: 575px) {
      top: 90px;
      max-width: calc(100% - 40px);
    }
  }

  .single-step-form--close-container {
    width: 30px;
    height: 30px;
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: center;

    .close-modal-button {
    }
  }
`;
